import { render, staticRenderFns } from "./VisitorManager.vue?vue&type=template&id=12a1555a&scoped=true&"
import script from "./VisitorManager.vue?vue&type=script&lang=js&"
export * from "./VisitorManager.vue?vue&type=script&lang=js&"
import style0 from "./VisitorManager.vue?vue&type=style&index=0&id=12a1555a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a1555a",
  null
  
)

export default component.exports